import { type ReactNode } from 'react';

export type CaptionMode = 'both' | 'photo-locked' | 'ig-locked' | 'both-locked';

type CaptionContent = { title: string; sub?: string };

const IG_SUB = "Nada de 'the3333games', 'debook' o 'jugador' en el nombre";

const CAPTIONS: Record<CaptionMode, CaptionContent> = {
  both: { title: 'Sube tu foto y tu @ de Instagram', sub: IG_SUB },
  'photo-locked': { title: 'Tu @ debe sonar orgánico', sub: IG_SUB },
  'ig-locked': { title: 'Sube tu foto de jugador' },
  'both-locked': { title: 'Confirma para finalizar tu verificación' },
};

const SUBMIT_LABELS: Record<CaptionMode, string> = {
  both: 'Subir y empezar prueba final',
  'photo-locked': 'Confirmar y empezar prueba final',
  'ig-locked': 'Subir foto y empezar prueba final',
  'both-locked': 'Verificar y empezar prueba final',
};

export function Caption({ mode }: { mode: CaptionMode }): ReactNode {
  const c = CAPTIONS[mode];
  return (
    <div className="flex w-full flex-col items-center gap-[2px] text-center">
      <p className="text-sm font-medium text-text-primary">{c.title}</p>
      {c.sub && (
        <p className="text-balance text-xs text-text-tertiary">{c.sub}</p>
      )}
    </div>
  );
}

export function FileInput(p: {
  inputRef: React.RefObject<HTMLInputElement | null>;
  pick: (f: globalThis.File) => void;
}): ReactNode {
  return (
    <input
      ref={p.inputRef}
      type="file"
      accept="image/*"
      capture="user"
      className="hidden"
      onChange={(e) => {
        const f = e.target.files?.[0];
        if (f) p.pick(f);
      }}
    />
  );
}

const BTN =
  'w-full rounded-md bg-brand-red px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-coral disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-brand-red';

export function PickBtn(p: {
  hasFile: boolean;
  disabled?: boolean;
  onClick: () => void;
}): ReactNode {
  const label = p.hasFile ? 'Cambiar foto' : 'Hacer foto';
  return (
    <button
      type="button"
      onClick={p.onClick}
      disabled={p.disabled}
      className={BTN}
    >
      {label}
    </button>
  );
}

export function SubmitBtn(p: {
  uploading: boolean;
  disabled: boolean;
  onConfirm: () => void;
  mode: CaptionMode;
}): ReactNode {
  return (
    <button
      type="button"
      disabled={p.disabled || p.uploading}
      onClick={p.onConfirm}
      className={BTN}
    >
      {p.uploading ? 'Subiendo...' : SUBMIT_LABELS[p.mode]}
    </button>
  );
}

export { PhotoTrigger } from './verification-photo-trigger';
